import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ThumbUp = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4452 3.35462C13.75 3.00702 12.9084 3.16421 12.3856 3.73934L8.05763 8.50007H5C3.89543 8.50007 3 9.3955 3 10.5001V18.5001C3 19.6046 3.89543 20.5001 5 20.5001H16.382C17.1395 20.5001 17.832 20.0721 18.1708 19.3945L20.7889 14.1584C20.9277 13.8807 21 13.5745 21 13.264V10.5001C21 9.3955 20.1046 8.50007 19 8.50007H14.7198L15.3705 5.2466C15.5239 4.47944 15.1449 3.7045 14.4452 3.35462ZM9.5 9.88668L13.2216 5.79288L12.5194 9.30395C12.4607 9.59773 12.5367 9.90237 12.7267 10.1341C12.9166 10.3657 13.2004 10.5001 13.5 10.5001H19V13.264L16.382 18.5001H9.5V9.88668ZM7.5 10.5001H5V18.5001H7.5V10.5001Z"
      fill="currentColor"
    />
  </Icon>
));

export default ThumbUp;
